import SettingsPage from './Settings';
export { SettingsPage };

